<div class="sti-dialog-container">
  <div class="sti-dialog-actions" [class.justify-end]="viewMode() === 'books'" [class.justify-between]="viewMode() !== 'books'">
    @if (viewMode() !== 'books') {
      <button mat-icon-button type="button" class="sti-dialog-icon-btn" (click)="onHomeClick()" aria-label="Back">
        <i class="fas fa-long-arrow-left"></i>
      </button>
    }
    <button mat-icon-button type="button" class="sti-dialog-icon-btn" (click)="onCloseClick()" aria-label="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="sti-dialog-content">
    @if (isLoading()) {
    <div class="center">
      <asg-pure-spinner></asg-pure-spinner>
    </div>
    }
    @if (error()) {
    <div class="error-message">
      {{ error() ?? '' | translate }}
    </div>
    }

    @if (!isLoading() && !error() && books().length > 0) {
    <asg-file-overview-table 
      tabindex="0" 
      [columnNames]="columnNames()" 
      [dataSource]="tableRows()"
      (rowSelected)="onMetadataSelected($event)"
    ></asg-file-overview-table>
    }

    @if (!isLoading() && !error() && books().length === 0) {
    <div class="center">
      {{ 'STI_DIALOG.NO_BOOKS_AVAILABLE' | translate }}
    </div>
    }
  </div>

  <div class="sti-dialog-bottom-actions">
    <button mat-stroked-button type="button" (click)="onCancelClick()">
      {{ 'STI_DIALOG.CANCEL' | translate }}
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!isFileSelected() || isOpeningFile()"
      (click)="onOpenClick()">
      {{ 'STI_DIALOG.OPEN' | translate }}
    </button>
  </div>
</div>